import { render, staticRenderFns } from "./ItemKapufa6m.vue?vue&type=template&id=8b594e42&scoped=true&"
import script from "./ItemKapufa6m.vue?vue&type=script&lang=js&"
export * from "./ItemKapufa6m.vue?vue&type=script&lang=js&"
import style0 from "./ItemKapufa6m.vue?vue&type=style&index=0&id=8b594e42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b594e42",
  null
  
)

export default component.exports